import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'; 
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { Utilityservice } from '../../utility/utilityservice.service';
import { LocationtypeService } from '../../main-layout/locationtype/locationtype.service';
@Component({
  selector: 'app-locationtypemodal',
  templateUrl: './locationtypemodal.component.html',
  styleUrls: ['./locationtypemodal.component.css']
})
export class LocationtypemodalComponent  extends BaseClass{
saveTitle = 'Add'
  isEdit: boolean = false;
  newlocationtypeupdate: any;
  locationtypedetails: any = {};
  locationTypeForm: FormGroup;
  CSRFToken = "";
  locationmodelid = null;
  newlocationtype: any;
  onlyView: any;
  countryOptions: any;
  labelName: String = "";
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  constructor(
    public override  injector: Injector,
    private LocationtypeService: LocationtypeService,
    private formBuilder: FormBuilder,
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice:Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.labelName = dataFromParent.labelName; 
    this.gettoken();
    if (dataFromParent?.title == 'Modify Location Type') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.locationtypedetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData(); 

    this.validation_message ={
      locationtypename: [
       { type: 'required', message: `${this.labelName} name is required` },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end.' },
       { type: 'iChars', message: 'Special characters are not allowed'   }, 
      { type: 'placeholder', message: `Enter  ${this.labelName}` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ]
    }
  }
 
  
  patchValueForms(data) {
    this.locationmodelid = data[0].locationmodelid;
    this.locationTypeForm.patchValue({ 'locationmodelid': data[0].locationmodelid });
    this.locationTypeForm.patchValue({ 'locationtypename': data[0].locationmodelname });
    this.locationTypeForm.patchValue({ 'activeflag': data[0].activeflag }); 
  }

  getData() {
    if (this.locationtypedetails.length !== undefined) {
      this.patchValueForms(this.locationtypedetails)
    }
  }

// iCharsValidator() {
//   return (control: any) => {
//     if (!control.value) return null;

//     const regex = VALIDATION_PATTERNS.iChars;
//     return regex.test(control.value) ? null : { iChars: true };
//   };
// }

  formInitiliaze() {

    this.locationTypeForm = this.formBuilder.group({
      locationtypename: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(200),
       
        Validators.pattern(VALIDATION_PATTERNS.iChars),

         //this.iCharsValidator()  ,
        //Validators.pattern(VALIDATION_PATTERNS.iChars),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW),
         Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      
      ])], 
      activeflag: ['Y']
    })
  }
  gettoken() {
    this.CSRFToken='';
           this.utilityservice.getCSRFtoken().subscribe(res=>{
           this.CSRFToken=res.csrf;
          },error=>{
            Swal.fire(error.error.message,'','error');
          });
  }
public validation_message: any;
  // public validation_message = {
  //   locationtypename: [
  //     { type: 'required', message: 'Location Type is required' },
  //     { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end.' },
  //     { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
  //     { type: 'placeholder', message: 'Enter Location Type' },
  //     { type: 'maxlength', message: 'Maximum length exceeded' },
  //     { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
  //   ]
  // }
  addLocationType() {
    const payload = {
      locationtypename: this.locationTypeForm.get('locationtypename').value, 
      activeflag: "Y", 
      csrftoken: this.CSRFToken,
    }; 
    if (this.saveTitle === 'Modify') {
      this.modifyLocationType(payload);
    } else {
      if (this.locationTypeForm.invalid) {
        this.validateAllFormFields(this.locationTypeForm); 
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`,
        }).then((value) => {
          if (value.isConfirmed) {
            this.LocationtypeService.addLocationType(payload).subscribe({
              next: (data) => {
                this.newlocationtype = data;
                if (this.newlocationtype.response === 'exists') {
                  Swal.fire(this.labelName +" already exists!", "", "error").then(() => {                    
                  });
                } else {
                  Swal.fire(this.labelName +" added successfully!", "", "success").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                Swal.fire({
                  title: "Error Saving "+this.labelName ,
                  text: error.error.message || "An unexpected error occurred.",
                  icon: "error",
                });
              },
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
            this.ref.close();
          }
        });
      }
    }
  }

  modifyLocationType(data: any) { 
    data["locationmodelid"] = this.locationmodelid;
    data["activeflag"] = this.locationTypeForm.get('activeflag').value;
    if (this.locationTypeForm.invalid) {
      this.validateAllFormFields(this.locationTypeForm);
            let invalidFields = [];
      for (const controlName in this.locationTypeForm.controls) {
        if (this.locationTypeForm.controls[controlName].invalid) {
          invalidFields.push(controlName); 
        }
      } 
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`,
      }).then((value) => {
        if (value.isConfirmed) {
          this.LocationtypeService.modifyLocationType(data).subscribe({
            next: (response) => {
              this.newlocationtypeupdate = response;
              if (this.newlocationtypeupdate.response === 'exists') {
                Swal.fire(this.labelName+" already exists!", "", "error").then(() => {
                });
              } else {
                Swal.fire(this.labelName+" is modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              Swal.fire({
                title: "Error Saving "+this.labelName,
                text: error.error.message || "An unexpected error occurred.",
                icon: "error",
              });
            },
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }
}
